import React from 'react';
import ReactDOM from 'react-dom/client';
import BookLaunchHero from './bookxxx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<BookLaunchHero />);
